import { render } from "./imgDetail.vue?vue&type=template&id=4ec56582&scoped=true"
import script from "./imgDetail.vue?vue&type=script&lang=js"
export * from "./imgDetail.vue?vue&type=script&lang=js"

import "./imgDetail.vue?vue&type=style&index=0&id=4ec56582&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/blog/blog/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ec56582"]])

export default __exports__